import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'Teranet-CustomizedEditor',
  templateUrl: './customized-editor.component.html',
})
export class CustomizedEditorComponent implements OnInit {
  @Input() public editorFormControl: FormControl;
  @Input() public form: FormGroup;
  @Input() cssClass: string;
  @Input() isReadonly: boolean = false;

  @ViewChild('editor', { read: ElementRef }) refEditor: ElementRef<HTMLElement>;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    let iframe = this.refEditor.nativeElement.getElementsByTagName('iframe');
    if (iframe && iframe.length > 0) {
      let content = iframe[0].contentDocument.getElementsByClassName('ProseMirror');
      if (content && content.length > 0) {
        if (this.isReadonly) {
          content[0].setAttribute('contenteditable', 'false');
        } else {
          content[0].setAttribute('contenteditable', 'true');
        }
      }
    }
  }
}
